import React from 'react';
import { format, isValid } from 'date-fns';
import { toDate } from 'utilities/date';
import { Box, Typography } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getAvatarName, getDocName } from './activityUtils';
import ActivityCard from './ActivityCard';

const RenderActivityList = ({ activityList }) => {
  const { requestsPageFeature } = useFlags();
  const groups = [];
  activityList?.forEach((activity, index) => {
    if (!requestsPageFeature && activity.type === 'wf_request') return;
    const date = toDate(activity.last_activity_at);
    const validDate = activity.last_activity_at && isValid(date);
    const month = validDate ? format(date, 'MMMM yyyy') : 'Date unavailable';
    const day = validDate ? format(date, 'yyyy-MM-dd') : null;
    let group = groups[groups.length - 1];
    if (!group || group.month !== month) {
      group = { month, key: `${month}-${index}`, entries: [], lastDay: null };
      groups.push(group);
    }
    group.entries.push({ activity, index, dayLabel: day !== group.lastDay && day ? format(date, 'EEE d') : null });
    group.lastDay = day;
  });

  function renderActivity(activity, index, dayLabel) {
    return (
      <ActivityCard
        activityType={activity.type}
        key={`${activity.type}-${activity.id}-${index}`}
        id={activity.id}
        entityEmailThreadId={activity.entity_email_thread_id}
        status={activity.status}
        avatarName={getAvatarName(
          activity.users?.length ? activity.users[0].full_name : activity.user,
        )}
        avatar={
          activity.users?.length ? activity.users[0].activity : activity.avatar
        }
        contactName={activity.user}
        user={
          activity.users?.length ? activity.users[0].full_name : activity.user
        }
        description={activity.description}
        subject={activity.subject}
        title={activity.title}
        percentComplete={activity.percent_complete}
        documents={getDocName(activity.documents, true)}
        lastActivityAt={activity.last_activity_at}
        dayLabel={dayLabel}
        // for task and invoice
        taskType={activity.task_type}
        invoiceNumber={activity.invoice_number}
        invoiceAmount={Number(activity.invoice_amount).toFixed(2)}
        dueBy={activity.due_by}
        uuid={activity.uuid}
        isRecurring
      />
    );
  }

  return (
    <div className="ActivityList">
      {groups.map((group) => (
        <Box component="section" aria-label={group.month} key={group.key} sx={{ mb: 1.875 }}>
          <Typography component="h2" variant="subtitle2" sx={{ mb: 0.625, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            {group.month}
          </Typography>
          <Box sx={{ bgcolor: 'background.paper', border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'hidden', '& .ActivityCard:not(:last-child)': { borderBottom: 1, borderColor: 'divider' } }}>
            {group.entries.map(({ activity, index: activityIndex, dayLabel }) =>
              renderActivity(activity, activityIndex, dayLabel))}
          </Box>
        </Box>
      ))}
    </div>
  );
};

export default RenderActivityList;
